module.exports = __webpack_public_path__ + "media/images/main-bg-8d642cb611a3ad12a8d08c08fc1d6120.png";